import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=7386fbe4&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports